import {appsSvg as Icon__small__appsSvg} from '../Icon__small/Icon__small--apps.js'
import {appsSvg as Icon__xsmall__appsSvg} from '../Icon__xsmall/Icon__xsmall--apps.js'

export var apps = {
  name: 'apps',
  category: 'icon',
  colorable: true,
  svg: Icon__small__appsSvg,
  alt: {
    Icon__small: Icon__small__appsSvg,
    Icon__xsmall: Icon__xsmall__appsSvg
  },
  combined: ['Icon__small', 'Icon__xsmall']
};
